'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultIcon = function DefaultIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('path', {
                fill: '#00D8C8',
                d: 'M10.14 59.95v-2.778H26.39v2.778zM32.266 59.95v-2.778h16.248v2.778z'
            }),
            _react2.default.createElement('path', {
                fill: '#FFCF3F',
                d: 'M28.183 7.59l.672.73-.031.035.42.388.187.203.018-.016.016.016.609-.591-.033-.035.672-.73-1.264-1.167z'
            }),
            _react2.default.createElement('path', {
                fill: '#F7F7F8',
                d: 'M16.513 31.823V14.218L29.39 1.844l12.988 12.374v17.605h-9.44V20.471H25.87v11.352z'
            }),
            _react2.default.createElement('path', {
                d: 'M57.146 40.618L44.25 52.913v3.276l-11.052.033v-7.307c0-1.008.392-1.955 1.105-2.667l6.328-6.33 4.08-4.081c.715 1.333.481 3.116-.663 4.263l-3.417 3.235-1.856 1.757 1.856.024 4.59.056c1.785.02 3.528-.687 4.738-1.9l5.402-4.668v-7.703c0-1.304.56-2.62 1.785-3.056v12.773zM53.517 30.9v6.858l-4.812 4.163a4.8 4.8 0 0 1-3.46 1.407l-1.902-.023 1.991-1.885a5.627 5.627 0 0 0 1.616-3.794c.041-1.476-.49-2.84-1.491-3.842l-.653-.652-4.175 4.177-7.632 7.634a5.58 5.58 0 0 0-1.645 3.971V59.971h1.844v-1.902h14.864v1.902h1.844v-3.746h-3.812v-2.523L58.99 41.407V25.85h-.922c-2.679 0-4.551 2.078-4.551 5.052zM14.75 56.189v-3.277L1.854 40.618V27.846c1.226.435 1.785 1.75 1.785 3.054v7.705l5.353 4.62a6.706 6.706 0 0 0 4.784 1.949l4.593-.06 1.855-.022-1.855-1.756-3.399-3.22c-1.15-1.15-1.396-2.97-.704-4.303l4.103 4.105 6.329 6.33a3.753 3.753 0 0 1 1.104 2.667v7.307l-11.052-.033zm11.052 3.782h1.844V48.915c0-1.5-.585-2.91-1.645-3.97L18.37 37.31l-4.204-4.207-.652.652c-2.036 2.036-1.967 5.547.171 7.683l1.971 1.867-1.9.025c-1.288.015-2.549-.496-3.508-1.454l-4.765-4.115V30.9c0-2.974-1.87-5.05-4.55-5.05H.01v15.556l12.896 12.295v2.523H9.093v3.746h1.844V58.07h14.865v1.902zM45.684 15.854L29.45.89 13.213 15.854l1.25 1.356L29.448 3.397 44.435 17.21zM42.383 32.375V17.553h-1.844v12.978h-6.453V19.682h-9.14v10.85h-6.59V17.552h-1.843v14.822H26.79V21.527h5.453v10.848z',
                fill: '#3F5060'
            }),
            _react2.default.createElement('path', {
                fill: '#FFCF3F',
                d: 'M37.3 13.658l-1.098-1.011-1.25 1.356 1.099 1.013zM30.562 9.957l1.097 1.013 1.25-1.358-1.098-1.011zM32.757 11.98l1.097 1.012 1.25-1.356-1.098-1.013zM25.987 9.612l1.25 1.357 1.098-1.012-1.25-1.356zM21.597 13.658l1.25 1.358 1.098-1.013-1.25-1.356zM23.792 11.636l1.25 1.356 1.098-1.011-1.25-1.358z'
            })
        )
    );
};

DefaultIcon.defaultProps = {
    width: '59',
    height: '60',
    viewBox: '0 0 59 60',
    xmlns: 'http://www.w3.org/2000/svg'
};

var ProfileIcon = function (_React$Component) {
    _inherits(ProfileIcon, _React$Component);

    function ProfileIcon() {
        _classCallCheck(this, ProfileIcon);

        return _possibleConstructorReturn(this, (ProfileIcon.__proto__ || Object.getPrototypeOf(ProfileIcon)).apply(this, arguments));
    }

    _createClass(ProfileIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(DefaultIcon, { fill: this.props.hover || this.props.active ? _colors.Colors.calmWhite : _colors.Colors.claimBlack, width: size + 'px', height: size + 'px' })
            );
        }
    }]);

    return ProfileIcon;
}(_react2.default.Component);

exports.default = ProfileIcon;